<template>
	<div class="expandable-content">
		<common-card type="dismiss" @dismiss="handleClose">
			<template v-if="activeContent.title" #title>
				<div class="expandable-content__title">
					{{ activeContent.title }}
					<span v-if="providerIntegrationsCount && !addingIntegration" class="int-count">
						{{ providerIntegrationsCount }}
					</span>
				</div>
			</template>
			<slot></slot>
			<template #footer>
				<slot name="footer"></slot>
			</template>
		</common-card>
	</div>
</template>

<script>
import { integration } from '@/integrations/mixins/integration';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('integrations');

export default {
	mixins: [integration],
	props: {
		/**
		 * Provider
		 */
		provider: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapState(['activeContent', 'addingIntegration']),
		providerIntegrationsCount() {
			return this.$get('provider.integrations.length', 0);
		},
	},
};
</script>
